module.exports = __webpack_public_path__ + "assets/img/most_like copy.69f9b475.svg";